import compose from 'lodash/fp/compose';
import lodashGroupBy from 'lodash/groupBy';
import { arrayOf, number, string } from 'prop-types';
import React from 'react';

import Tabs from '../../generic/Tabs';
import Titled from '../../layout/Titled';
import { basicCampaignShape, campaignBudgetsShape } from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import BudgetData from '../BudgetData';
import { defaultListColumns } from '../campaign-columns';
import { allStatusesEnum } from '../constants';
import List from '../List';
import dump from '../utils/dump';

class ListMyCampaigns extends React.PureComponent {
  tabs() {
    const { data, relevantFor, relevantForSalesTeam } = this.props;
    const groupedData = lodashGroupBy(data, 'status');

    function determineColumns(columns) {
      return columns.filter(col => col.Header !== 'Owner');
    }

    function statusTab(status, columns) {
      const statusData = groupedData[status.value] || [];
      return {
        label: `${status.label} (${statusData.length})`,
        value: status.value,
        disabled: !statusData.length,
        content: (
          <List
            data={statusData}
            columns={determineColumns(columns)}
            dump={dump}
            exportParams={{
              status: status.value,
              relevantFor,
              relevantForSalesTeam,
            }}
          />
        ),
      };
    }

    const allTab = {
      label: `ALL (${data.length})`,
      value: 'all',
      disabled: !data.length,
      content: (
        <List
          data={data}
          columns={determineColumns(defaultListColumns)}
          displayExportButton
          exportParams={{ relevantFor, relevantForSalesTeam }}
        />
      ),
    };

    return [
      allTab,
      statusTab(allStatusesEnum.SETUP_PROGRESS, defaultListColumns),
      statusTab(allStatusesEnum.RUNNING, defaultListColumns),
      statusTab(allStatusesEnum.PAUSED, defaultListColumns),
    ];
  }

  render() {
    const { budgets } = this.props;

    return (
      <Titled
        title={
          <BudgetData
            openBudget={budgets.openBudget}
            securedBudget={budgets.securedBudget}
            securedPushedBudget={budgets.securedPushedBudget}
            openChangeRequests={budgets.openChangeRequests}
          />
        }
        size="reg"
        className="mt-2"
      >
        <Tabs
          tabs={this.tabs()}
          defaultActive={allStatusesEnum.RUNNING.value}
          id="myCampaigns"
        />
      </Titled>
    );
  }
}

ListMyCampaigns.propTypes = {
  data: arrayOf(basicCampaignShape.isRequired),
  relevantFor: number,
  relevantForSalesTeam: string,
  budgets: campaignBudgetsShape.isRequired,
};

ListMyCampaigns.defaultProps = {
  data: [],
  relevantFor: undefined,
  relevantForSalesTeam: undefined,
};

export default compose(
  withResolved({
    query: api.getCampaignsBasic,
    deriveQueryArgs: ({ relevantFor, relevantForSalesTeam }) => ({
      search: { relevantFor, relevantForSalesTeam },
    }),
    as: 'data',
  }),
  withResolved({
    query: api.getCampaignBudgets,
    deriveQueryArgs: ({ relevantFor, relevantForSalesTeam }) => ({
      search: { relevantFor, relevantForSalesTeam },
    }),
    as: 'budgets',
  }),
)(ListMyCampaigns);
